import * as z from 'zod';

export const designationFormSchema = z.object({
  Title: z.string().min(1, { message: 'TITLE_REQUIRED' }),
  Weight: z.coerce.number().int().positive({ message: 'WEIGHT_MUST_BE_POSITIVE_INTEGER' }),
});

export type DesignationFormValues = z.infer<typeof designationFormSchema>;
